import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { useForm, Controller } from 'react-hook-form';
import {
  FormControl,
  Grid,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  Checkbox,
} from '@mui/material';
import Swal from 'sweetalert2';

import { Modal } from '../../../components/BootstrapToMUI';
import request from '../../../services/Request';

export default function DiscountModal(props) {
  const { data, setReflesh, reflesh, id, setMobile, ...rest } = props;
  const defaultValues = {
    pg_radio: data?.pg_radio || '1',
    pg_point: data?.pg_point || 10,
    login_type_radio: data?.login_type_radio || '0',
    minimum_points: data?.minimum_points || 100,
  };
  const { handleSubmit, reset, watch, control, register, setValue } = useForm({ defaultValues });

  const watchAll = watch();

  useEffect(() => {
    if (props.show) {
      reset(defaultValues);
    }
  }, [props.show]);

  const onSubmit = async (formData) => {
    console.log('formData', formData);
    if (formData.pg_radio === '0') {
      formData.pg_point = 0;
    }

    request({
      method: 'patch',
      url: `/clientUser/editMemberSetting`,
      data: {
        id: id,
        mobileSetting: {
          pg_radio: formData.pg_radio,
          pg_point: formData.pg_point,
          minimum_points: formData.minimum_points,
          login_type_radio: formData.login_type_radio,
        },
      },
    }).then(() => {
      setMobile({
        pg_radio: formData.pg_radio,
        pg_point: formData.pg_point,
        minimum_points: formData.minimum_points,
        login_type_radio: formData.login_type_radio,
      });
      Swal.fire({
        title: 'Success',
        text: 'Member setting has been successfully updated',
      }).then(() => {
        props.onHide();
      });
    });

    // return console.log('formData', formData);
  };

  return (
    <Modal className="modal-w" {...rest} centered size="md">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Edit Member setting</Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body">
        <form
          onSubmit={handleSubmit(onSubmit)}
          noValidate
          style={{ textAlign: 'center', padding: '0 40px' }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} style={{ padding: '0 8px', marginTop: '15px' }} className="mt-">
              <FormControl component="fieldset" style={{ width: '100%' }}>
                <FormLabel component="legend">Points Gain</FormLabel>
                <RadioGroup
                  row
                  name="pg_radio"
                  {...register('pg_radio1', {
                    onChange: (e) => {
                      setValue('pg_radio', e.target.value);
                    },
                  })}
                >
                  <FormControlLabel
                    style={{ minWidth: '25%' }}
                    value="0"
                    control={<Radio />}
                    label="1 dollar gain X point"
                    checked={watchAll.pg_radio === '0'}
                  />
                  <FormControlLabel
                    style={{ minWidth: '25%' }}
                    value="1"
                    control={<Radio />}
                    label={`1 transaction = X points`}
                    checked={watchAll.pg_radio === '1'}
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12} style={{ padding: '0 8px' }}>
              <TextField
                variant="outlined"
                margin="normal"
                type="number"
                required
                fullWidth
                id="pg_point"
                label="Points"
                name="pg_point"
                inputProps={{ min: 0 }}
                autoComplete="pg_point"
                value={watchAll.pg_point}
                {...register('pg_point')}
              />
            </Grid>

            <FormLabel component="legend" className="mt-2">
              Minimum Points Required For Redeem
            </FormLabel>
            <Grid item xs={12} style={{ padding: '0 8px' }}>
              <TextField
                variant="outlined"
                margin="normal"
                type="number"
                required
                fullWidth
                id="min"
                label="Minimum Points Required For Redeem"
                name="minimum_points"
                inputProps={{ min: 0 }}
                autoComplete="minimum_points"
                value={watchAll.minimum_points}
                {...register('minimum_points')}
              />
            </Grid>
            <div className="ml-2">{`The exchange rate is always 100 points for 1 dollar.`}</div>
            <Grid item xs={12} style={{ padding: '0 8px', marginTop: '15px' }} className="mt-">
              <FormControl component="fieldset" style={{ width: '100%' }}>
                <FormLabel component="legend">Login Type</FormLabel>
                <RadioGroup
                  row
                  name="login_type_radio"
                  {...register('login_type_radio1', {
                    onChange: (e) => {
                      setValue('login_type_radio', e.target.value);
                    },
                  })}
                >
                  <FormControlLabel
                    style={{ minWidth: '25%' }}
                    value="0"
                    control={<Radio />}
                    label="Default"
                    checked={watchAll.login_type_radio === '0'}
                  />
                  <FormControlLabel
                    style={{ minWidth: '25%' }}
                    value="1"
                    control={<Radio />}
                    label={`Require Pin for Checkout`}
                    checked={watchAll.login_type_radio === '1'}
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            {/* <Grid item xs={12} style={{ padding: '0 8px' }}></Grid> */}
          </Grid>

          <Button variant="contained" color="primary" type="submit" className="mt-3">
            Submit
          </Button>
        </form>
      </Modal.Body>
    </Modal>
  );
}
